<div class="container">
  <div class="text-center justify-content-center">
    <h3 class="mainHeading slide-in-left">Baldia Order History</h3>
  </div>

  <!-- Search Box Section -->
  <div class="row align-items-end slide-up">
    <!-- Left side: Export and Print buttons -->
    <div class="col-md-4 d-flex flex-wrap gap-2">
      <button
        class="btn btn-outline-secondary"
        type="button"
        (click)="exportToExcel()"
      >
        <i class="bi bi-box-arrow-up me-2"></i> Export
      </button>
      <button
        class="btn btn-outline-secondary"
        type="button"
        (click)="exportToPDF()"
      >
        <i class="bi bi-printer me-2"></i> Print
      </button>
    </div>

    <!-- Right side: Search input -->
    <div class="col-md-8 d-flex justify-content-end">
      <div class="col-md-4 col-sm-6">
        <label for="search" class="form-label">Search</label>
        <input
          id="search"
          type="text"
          class="form-control"
          placeholder="Search..."
          (input)="onSearch($event)"
        />
      </div>
    </div>
  </div>

  <!-- Tabs Navigation -->
  <div class="card p-3 shadow-lg mt-3 slide-up">
    <ul class="nav nav-tabs cursor-pointer mt-3" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'Pending'"
          [ngClass]="{ 'custom-active-tab': activeTab === 'Pending' }"
          (click)="setActiveTab('Pending')"
        >
          Pending
        </a>
      </li>
      <li class="nav-item cursor-pointer" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'approved'"
          [ngClass]="{ 'custom-active-tab': activeTab === 'approved' }"
          (click)="setActiveTab('approved')"
        >
          Approved
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'Denied'"
          [ngClass]="{ 'custom-active-tab': activeTab === 'Denied' }"
          (click)="setActiveTab('Denied')"
        >
          Denied
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'Re-Submitted'"
          [ngClass]="{ 'custom-active-tab': activeTab === 'Re-Submitted' }"
          (click)="setActiveTab('Re-Submitted')"
        >
          Re-Submitted
        </a>
      </li>
    </ul>

    <!-- Tab Content -->
    <div class="tab-content">
      <div class="tab-pane fade show active">
        <div
          class="table-responsive custom-table-width"
          style="max-width: 100%; overflow-x: auto"
        >
          <table class="table table-bordered table-striped table-hover">
            <thead>
              <tr class="cursor-pointer">
                <th class="text-center">Order Id</th>
                <th class="text-center">Requestor Type</th>
                <th class="text-center">City</th>
                <th class="text-center">Requestor Name</th>
                <th class="text-center">Requestor mobile no</th>
                <th class="text-center">Order Created Date</th>
                <th class="text-center">Container Drop Request Date</th>
                <th class="text-center">Container Delivered Date</th>
                <th class="text-center">No of trips</th>
                <th class="text-center">Actual trips</th>
                @if(activeTab == 'approved') {
                <th class="text-center">Dumpster Name</th>
                <th class="text-center">Dumpster mobile no</th>
                <th class="text-center">Dump Yard Name</th>
                <th class="text-center">Dump Yard Mobile No</th>
                }
                <th class="text-center">Order Status</th>
                <th class="text-center">Order Timeline</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of pagedData; let i = index">
                <!-- <td class="text-center">{{ (currentPage - 1) * pageSize + i + 1 }}</td> -->
                <td
                  class="custom-width"
                  (click)="openDetailModal(detailsModal, row)"
                  class="text-center custom-column-width"
                >
                  <a class="hyperLink ">{{ row.orderId }}</a>
                </td>
                <td class="text-center custom-width">
                  {{ row.requestorType }}
                </td>
                <td class="text-center custom-width">{{ row.city }}</td>
                <td class="text-center custom-width">
                  {{
                    row.requestorType == "Individual Requester"
                      ? row.requestorName
                      : row.companyName
                  }}
                </td>
                <td class="text-center custom-width">
                  {{ row.requestorMobile }}
                </td>
                <td class="text-center custom-column-width">
                  {{ row.requestDate | date : "dd MMM yyy" }}
                </td>
                <td class="text-center custom-column-width">
                  {{ row.scheduledDate | date : "dd MMM yyy" }}
                </td>
                <td class="text-center custom-width">
                  {{ row.containerDeliveryDate | date : "dd MMM yyyy" }}
                </td>
                <td class="text-center custom-width">{{ row.noOfTotalTrips }}</td>
                <td class="text-center custom-width">{{ row.noOfActualTrips }}</td>
                @if (activeTab == 'approved') {
                <td class="text-center custom-width">
                  {{ row.dumbsterCompanyName }}
                </td>
                <td class="text-center custom-width">
                  {{ row.dumpsterMobileNo }}
                </td>
                <td class="text-center custom-column-width">
                  {{
                    row.currentOrderStatusID == 114
                      ? "-"
                      : row.dumpyardCompanyName
                  }}
                </td>
                <td class="text-center custom-column-width">
                  {{
                    row.currentOrderStatusID == 114 ? "-" : row.dumpyardMobileNo
                  }}
                </td>
                }
                <td class="text-center" style="width: 13%; text-align: center">
                  {{ row.currentOrderStatus }}
                </td>
                <td
                  class="text-center hyperLink"
                  (click)="navigate(row?.orderId)"
                >
                  View Timeline
                </td>
              </tr>
              <tr *ngIf="!pagedData || pagedData.length === 0">
                <td class="text-center" colspan="17">
                  <h3>No data available</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div
      class="d-flex mt-2 justify-content-center"
      *ngIf="requestData?.length > 0"
    >
      <ngb-pagination
        [(page)]="currentPage"
        [pageSize]="pageSize"
        [collectionSize]="totalItems"
        (pageChange)="pageChanged($event)"
        [maxSize]="3"
        [boundaryLinks]="true"
      >
      </ngb-pagination>
    </div>
    <div *ngIf="pagedData?.length > 0" class="text-muted text-end mb-3">
      <strong
        >Showing {{ (currentPage - 1) * pageSize + 1 }} to
        {{
          currentPage * pageSize > pagedData?.length
            ? pagedData?.length
            : currentPage * pageSize
        }}
        of {{ pagedData?.length }} entries</strong
      >
    </div>
  </div>
</div>

<!--------------------------------- Details popup --------------------------------->

<ng-template #detailsModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-3">Order Details - ({{ selectedOrderId }})</h3>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <form [formGroup]="orderForm">
    <div class="modal-body custom-modal">
      <!-- User Type Form Group -->
      <div class="mb-3 row">
        <label for="userType" class="col-sm-4 col-form-label text-start"
          >Requestor Type</label
        >
        <div class="col-sm-8">
          <input
            id="userType"
            formControlName="userType"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Company Name Form Group -->
      <div class="mb-3 row">
        <label for="companyName" class="col-sm-4 col-form-label text-start">
          Name</label
        >
        <div class="col-sm-8">
          <input
            id="companyName"
            formControlName="companyName"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Mobile Number Form Group -->
      <div class="mb-3 row">
        <label for="mobileNumber" class="col-sm-4 col-form-label text-start">
          Mobile Number</label
        >
        <div class="col-sm-8">
          <input
            id="mobileNumber"
            formControlName="mobileNumber"
            class="form-control"
            [readonly]="true"
            type="text"
          />
        </div>
      </div>

      <!-- Address Form Group -->
      <div class="mb-3 row">
        <label for="location" class="col-sm-4 col-form-label text-start">
          Location</label
        >
        <div class="col-sm-8">
          <textarea
            id="location"
            formControlName="location"
            class="form-control"
            [readonly]="true"
            rows="3"
          ></textarea>
        </div>
      </div>

      <!-- Email Form Group -->
      <div class="mb-3 row">
        <label for="city" class="col-sm-4 col-form-label text-start"
          >City</label
        >
        <div class="col-sm-8">
          <input
            id="city"
            formControlName="city"
            class="form-control"
            [readonly]="true"
            type="email"
          />
        </div>
      </div>

      <!-- City Form Group -->
      <div class="mb-3 row">
        <label for="zone" class="col-sm-4 col-form-label text-start"
          >Zone</label
        >
        <div class="col-sm-8">
          <input
            id="zone"
            formControlName="zone"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- Zone Form Group -->
      <div class="mb-3 row">
        <label for="reqDate" class="col-sm-4 col-form-label text-start"
          >Request Date & Time</label
        >
        <div class="col-sm-8">
          <input
            id="reqDate"
            formControlName="reqDate"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- Bank Name Form Group -->
      <div class="mb-3 row">
        <label for="scheduledDate" class="col-sm-4 col-form-label text-start"
          >Scheduled Date & Time</label
        >
        <div class="col-sm-8">
          <input
            id="scheduledDate"
            formControlName="scheduledDate"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Container Name No Form Group -->
      <div class="mb-3 row">
        <label for="containerName" class="col-sm-4 col-form-label text-start"
          >Container Type</label
        >
        <div class="col-sm-8">
          <input
            id="containerName"
            formControlName="containerName"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- Bank Account No Form Group -->
      <div class="mb-3 row">
        <label
          for="containerCapacity"
          class="col-sm-4 col-form-label text-start"
          >Container Capacity (m³)</label
        >
        <div class="col-sm-8">
          <input
            id="containerCapacity"
            formControlName="containerCapacity"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- CR Number Form Group -->
      <div class="mb-3 row">
        <label for="containerCount" class="col-sm-4 col-form-label text-start"
          >No Of Containers</label
        >
        <div class="col-sm-8">
          <input
            id="containerCount"
            formControlName="containerCount"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- CR Document Form Group -->
      <div class="mb-3 row">
        <label for="rentalDuration" class="col-sm-4 col-form-label text-start"
          >Rental Duration (Week)</label
        >
        <div class="col-sm-8">
          <input
            id="rentalDuration"
            formControlName="rentalDuration"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- <div class="mb-3 row">
        <label for="sar" class="col-sm-4 col-form-label text-start">SAR</label>
        <div class="col-sm-8">
          <input
            id="sar"
            formControlName="sar"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div> -->
    </div>
  </form>
</ng-template>

<ng-template #downloadInvoiceModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-3">Download Invoice</h3>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal">
    <p>Choose the invoice type:</p>
    <select
      class="form-select"
      aria-label="Invoice type"
      [(ngModel)]="invoiceType"
    >
      <!-- <option selected value="">Select invoice type</option> -->
      <option selected value="Initial Requestor Invoice">
        Initial Requestor Invoice
      </option>
      <option
        value="Requestor Refund Invoice"
        [disabled]="requesterStatusCode == null || requesterStatusCode == '0'"
      >
        Requestor Refund Invoice
      </option>
      <option
        value="Dumpster Invoice"
        [disabled]="dumpsterStatusCode == null || dumpsterStatusCode == '0'"
      >
        Dumpster Invoice
      </option>
      <option
        value="Dump Yard Invoice"
        [disabled]="dumpyardStatusCode == null || dumpyardStatusCode == '0'"
      >
        Dump Yard Invoice
      </option>
    </select>
    <button
      type="button"
      class="btn btn-primary mt-3 mb-2"
      (click)="downLoadInvoice()"
    >
      Download
    </button>
  </div>
</ng-template>

<ng-template #paymentDetailsModal let-modal>
  <div class="modal-header custom-modal-header">
    <h2 class="modal-title mt-3">Payment Details</h2>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <form [formGroup]="paymentForm">
    <div
      class="modal-body custom-modal"
      style="max-height: 500px; overflow-y: scroll"
    >
      <!-- Requestor Bank Details -->
      <h2 class="text-center" style="background-color: #8e0e00; color: white">
        Requester
      </h2>
      <div class="mb-3 row">
        <label for="sarReceivedReq" class="col-sm-4 col-form-label text-start">
          SAR Received</label
        >
        <div class="col-sm-8">
          <input
            id="sarReceivedReq"
            formControlName="sarReceivedReq"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>
      <div class="mb-3 row">
        <label for="sarRefundedReq" class="col-sm-4 col-form-label text-start"
          >SAR Refunded</label
        >
        <div class="col-sm-8">
          <input
            id="sarRefundedReq"
            formControlName="sarRefundedReq"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Dumpster Bank Details -->
      <h2 class="text-center" style="background-color: #8e0e00; color: white">
        Dumpster
      </h2>
      <div class="mb-3 row">
        <label for="sarDumpster" class="col-sm-4 col-form-label text-start"
          >SAR Credited</label
        >
        <div class="col-sm-8">
          <input
            id="sarDumpster"
            formControlName="sarDumpster"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Dump Yard Bank Details -->
      <h2 class="text-center" style="background-color: #8e0e00; color: white">
        Dump yard
      </h2>
      <div class="mb-3 row">
        <label for="sarDumpyard" class="col-sm-4 col-form-label text-start"
          >SAR Credited</label
        >
        <div class="col-sm-8">
          <input
            id="sarDumpyard"
            formControlName="sarDumpyard"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Smartsort Bank Details -->
      <h2 class="text-center" style="background-color: #8e0e00; color: white">
        Smart-Sort
      </h2>
      <div class="mb-3 row">
        <label for="sarSmartSort" class="col-sm-4 col-form-label text-start"
          >SAR Credited</label
        >
        <div class="col-sm-8">
          <input
            id="sarSmartSort"
            formControlName="sarSmartSort"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>
    </div>
  </form>
</ng-template>

@if(isLoading) {
<app-loader></app-loader>
}
